const drawer = document.querySelector('#drawer');
const exit = document.querySelector('#exit');
const hamburger = document.querySelector("#hamburger");
const overlay = document.querySelector("#overlay");

function lockBodyScroll() {
  document.body.classList.add('drawer-open');
}

function unlockBodyScroll() {
  document.body.classList.remove('drawer-open');
}

function drawerOpen() {
  drawer.classList.add("drawer--active");
  overlay.classList.add("overlay--active");
  lockBodyScroll();
}

function drawerClose() {
  drawer.classList.remove("drawer--active");
  overlay.classList.remove("overlay--active");
  unlockBodyScroll();
}

function hideDrawerByDocument(e) {
  if(!drawer.contains(e.target) && !hamburger.contains(e.target)) {
    drawer.classList.remove("drawer--active");
    overlay.classList.remove("overlay--active");
    unlockBodyScroll();
  }
}

hamburger.addEventListener('click', drawerOpen);
exit.addEventListener('click', drawerClose);
overlay.addEventListener('click', drawerClose);
document.addEventListener('click', hideDrawerByDocument);